import { createFileRoute } from '@tanstack/react-router';
import { Heading } from '@osd/ui/heading';
import { Stack } from '@osd/ui/stack';
import { Text } from '@osd/ui/text';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/utilities — live docs for the Bootstrap-style helper
 * classes (.osd-mt-3, .osd-d-flex, etc.) generated from the
 * $osd-utilities Sass map in _utilities.scss.
 */
export const Route = createFileRoute('/ui/_layout/utilities')({
  component: UtilitiesPage,
});

function UtilitiesPage() {
  return (
    <Stack gap={6}>
      <Section
        title="Utilities"
        hint="spacing, color, flex, text — Bootstrap-style helpers via .osd-* classes"
      >
        <Stack gap={4}>
          <div className="osd-mb-4 osd-text-center">
            <Heading level={3}>Spacing + alignment</Heading>
          </div>
          <div className="osd-bg-surface-2 osd-p-4 osd-rounded-md">
            <Text>Surface-2 background, padding-4, rounded-md.</Text>
          </div>
          <div className="osd-d-flex osd-gap-3 osd-justify-content-between">
            <Text>Left</Text>
            <Text>Right</Text>
          </div>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Spacing — margin / padding"
            hint="Scale matches the --osd-space-* tokens (1 = 4px, 8 = 64px)"
            language="html"
            code={`<div className="osd-mt-4 osd-mb-2 osd-p-3">
  Margin top 4, bottom 2, padding 3.
</div>`}
          />

          <CodeBlock
            title="Auto margins — centering"
            language="html"
            code={`<div className="osd-mx-auto" style={{ maxWidth: '480px' }}>
  Centered with a max width.
</div>`}
          />

          <CodeBlock
            title="Flex helpers"
            language="html"
            code={`<div className="osd-d-flex osd-gap-3 osd-align-items-center osd-justify-content-between">
  <span>Left</span>
  <span>Right</span>
</div>`}
          />

          <CodeBlock
            title="Text helpers"
            language="html"
            code={`<Text className="osd-text-center osd-text-muted">Muted, centered.</Text>
<Text className="osd-fw-bold">Bold weight.</Text>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
